module.exports = __webpack_public_path__ + "img/logo-dark.2bf21423.png";